// src/pages/DeletedPurchasesPage.js
import React, { useState, useEffect } from 'react';
import { formatDate } from '../utils/formatDate';
import './PurchasesPage.css';
import { API_URL } from "../config";

function DeletedPurchasesPage() {
    const [purchases, setPurchases] = useState([]);

    useEffect(() => {
        fetchDeletedPurchases();
    }, []);

    const fetchDeletedPurchases = async () => {
        try {
            const response = await fetch(`${API_URL}/purchases/deleted`, {
                credentials: 'include',
            });
            if (!response.ok) throw new Error('Błąd pobierania odrzuconych zamówień.');
            const data = await response.json();
            setPurchases(data);
        } catch (error) {
            console.error('Błąd:', error);
        }
    };

    const handleRestore = async (id) => {
        if (window.confirm('Czy na pewno chcesz przywrócić to zamówienie?')) {
            try {
                const response = await fetch(`${API_URL}/purchases/${id}/restore`, {
                    method: 'PUT',
                    credentials: 'include',
                });
                if (!response.ok) throw new Error('Błąd przywracania zamówienia.');
                setPurchases(purchases.filter(p => p.id !== id));
            } catch (error) {
                console.error('Błąd:', error);
                alert('Wystąpił błąd podczas przywracania zamówienia.');
            }
        }
    };

    return (
        <div className="purchases-page">
            <header className="purchases-header">
                <h2>Zamówienia Odrzucone</h2>
            </header>
            <section className="purchases-grid">
                {purchases.length === 0 ? (
                    <p>Brak odrzuconych zamówień.</p>
                ) : (
                    purchases.map(purchase => (
                        <div key={purchase.id} className="purchase-card">
                            <span className="purchase-number">#{purchase.nr_zamowienia}</span>
                            <p><strong>Nr Zlecenia:</strong> {purchase.nr_ref}</p>
                            <p><strong>Tytuł Zamówienia:</strong> {purchase.tytul_zamowienia}</p>
                            <p><strong>Osoba Zamawiająca:</strong> {purchase.first_name} {purchase.last_name}</p>
                            <p><strong>Data Zamówienia:</strong> {formatDate(purchase.data_utworzenia)}</p>
                            <p><strong>Termin Realizacji:</strong> {formatDate(purchase.termin_realizacji)}</p>
                            <p><strong>Status:</strong> {purchase.status}</p>
                            <button className="btn-submit" onClick={() => handleRestore(purchase.id)}>
                                Przywróć
                            </button>
                        </div>
                    ))
                )}
            </section>
        </div>
    );
}

export default DeletedPurchasesPage;